import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseOffer } from "./UseOffer";
import OfferInformation from "./OfferInformation";
import AddProductOff from "./AddProductOff";
import ProductsGrid from "./ProductsGrid";

export default function Offers(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { HomeOffer } = UseOffer();
  const [offers, setOffers] = useState();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  useEffect(() => {
    setProgress(true);
    HomeOffer(location.state.OfferID, (callback) => {
      setOffers(callback);
    });
  }, []);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/ProductOffers",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            فریم نمایش
          </Typography>
          <OfferInformation
            aid={location.state.OfferID}
            offers={offers && offers}
            setOffers={setOffers}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            محصولات
          </Typography>
          <ProductsGrid
            thisOfferId={offers && offers.id ? offers.id : undefined}
            OfferID={offers && offers.id}
            rows={offers && offers.products}
            offers={offers && offers}
            setOffers={setOffers}
            callback={() => {
              HomeOffer(location.state.OfferID, (callback) => {
                setOffers(callback);
              });
            }}
          />
          <AddProductOff
            thisOfferId={offers && offers.id ? offers.id : undefined}
            rows={offers && offers.products}
            offers={offers && offers}
            setOffers={setOffers}
            OfferID={offers && offers.id}
            callback={() => {
              HomeOffer(location.state.OfferID, (callback) => {
                setOffers(callback);
              });
            }}
          />
        </Box>
      </Box>
    </Detail>
  );
}
